// Display name for a PP account, with a "(disabled)" marker when the account is disabled.
// Disabled accounts stay listed and selectable everywhere, so the marker is the only signal.
export const formatPpAccountLabel = (account: {
  name?: string | null;
  shop?: string | null;
  ppAccountId: number;
  enabled?: boolean;
}): string => {
  const base = account.name || account.shop || `#${account.ppAccountId}`;
  return account.enabled === false ? `${base} (disabled)` : base;
};
